import { render, staticRenderFns } from "./TtArticle.vue?vue&type=template&id=198e7c18"
import script from "./TtArticle.vue?vue&type=script&lang=ts"
export * from "./TtArticle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports